export default "__VITE_ASSET__CGcqZl54__"